import { API } from '@/config';
import type { OpsSettings, UpdateOpsSettingsRequest } from '@/types';
import { api } from './client';

/**
 * The ops settings: auto-halt, second approval, on-call paging, debug-log
 * retention. Reading is open to the ops portal; changing them is superadmin
 * and engineering, refused server-side for anyone else.
 */
export const settingsService = {
  get: (signal?: AbortSignal): Promise<OpsSettings> =>
    api.get<OpsSettings>(API.endpoints.settings, signal ? { signal } : {}),

  /** Only what changed. */
  update: (body: UpdateOpsSettingsRequest): Promise<OpsSettings> =>
    api.put<OpsSettings>(API.endpoints.settings, body),

  /** A page to the on-call address, whether paging is on or not. */
  testPage: (): Promise<{ sentTo: string }> =>
    api.post<{ sentTo: string }>(API.endpoints.settingsTestPage, {}),
};
